import { User } from '@hakimo-ui/hakimo/types';
import {
  DescriptionList,
  DescriptionListItem,
} from '@hakimo-ui/hakimo/ui-elements';
import ProfileSection from '../profile-section/ProfileSection';

export interface Props {
  user: User;
}

export function General(props: Props) {
  const { user } = props;

  const listItems: DescriptionListItem[] = [
    {
      name: 'Name',
      value: user.name ?? '-',
    },
    {
      name: 'Email',
      value: user.email,
    },
    {
      name: 'Roles',
      value: user.roles.join(', '),
    },
    {
      name: 'Tenant',
      value: user.tenantName,
    },
  ];

  const account = <DescriptionList items={listItems} />;

  return <ProfileSection title="Account" content={account} />;
}

export default General;
